import React, { useState } from 'react';

function Generatearts() {
    const [text, setText] = useState(""); // 保存したい文字列を管理

    const saveAsJsFile = () => {
        const jsContent = text || "// デフォルトのJavaScriptコード\nconsole.log('Hello, World!');";
        const blob = new Blob([jsContent], { type: "application/javascript" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "script.js";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    return (
        <div style={{ padding: "20px" }}>
            <h1>文字列を.jsファイルとして保存</h1>
            <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="ここにJavaScriptコードを入力してください"
                rows={10}
                cols={50}
            />
            <br />
            <button onClick={saveAsJsFile}>保存 (.js)</button>
        </div>
    );
}

export default Generatearts;